import { RHFAutoCompleteVirtualize } from '@openx/components-core/lib/AutoComplete/RHFAutoCompleteVirtualize.tsx';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection.tsx';
import { RHFTextField } from '@openx/components-core/lib/TextField/RHFTextField.tsx';
import { RIGHT_COLUMN_WIDTH } from '@openx/constants/form.ts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { ContentCategoryOption } from '../types.ts';
import { getContentCategoryOptionsMap } from '../utils.ts';
import type { CreativeFormState } from './validation/validationSchema.ts';

type CreativeContentDetailsSectionProps = {
  iabCategoryOptions: ContentCategoryOption[];
};

export const CreativeContentDetailsSection = ({ iabCategoryOptions }: CreativeContentDetailsSectionProps) => {
  const { t } = useTranslation();

  const { iabCategoryOptionsMap, iabCategoryOptionKeys } = useMemo(() => {
    const map = getContentCategoryOptionsMap(iabCategoryOptions);

    return { iabCategoryOptionsMap: map, iabCategoryOptionKeys: Object.keys(map) };
  }, [iabCategoryOptions]);

  return (
    <FormSection divider title={t('Content Details')} rightColumnSize={RIGHT_COLUMN_WIDTH}>
      <RHFAutoCompleteVirtualize
        name={'iab_categories' satisfies keyof CreativeFormState}
        options={iabCategoryOptionKeys}
        getOptionLabel={option => iabCategoryOptionsMap[option] || option}
        multiple
        limitTags={3}
        fullWidth
        data-test="iab-categories"
        textFieldProps={{
          label: t('IAB Categories (Optional)'),
          placeholder: t('[ Select IAB Categories ]'),
          margin: 'dense',
        }}
      />

      <RHFTextField
        name={'advertiser_domain' satisfies keyof CreativeFormState}
        label={t('Advertiser Domain (Optional)')}
        placeholder={t('Enter domain, e.g. example.com')}
        fullWidth
        dataTest="advertiser-domain"
        margin="dense"
      />
    </FormSection>
  );
};
